export default function openHelpScout() {
  window.Beacon?.("open");
}
